<template lang="html">
  <div id="text-page">
    <div class="container">
      <h1 class="mb-2 page-title">TÉRMINOS Y CONDICIONES</h1>
      <div class="d-block" v-html="content.body"></div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      content: '',
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/api/terminos')).then((response)=>{
        this.content = response.data;;
      }).catch((error)=>{
        console.log(error);
      })
    }
  },

  beforeMount(){
    this.getContent();
  }
}
</script>
